import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ImageSectionHeadComponent } from '../../components/image-section-head/image-section-head.component';
import { AuthService } from '../../services/auth/auth.service';
import { AccessComponent } from '../../components/access/access.component';

@Component({
  selector: 'app-access-page',
  standalone: true,
  imports: [ImageSectionHeadComponent, AccessComponent],
  templateUrl: './access-page.component.html',
  styleUrl: './access-page.component.scss'
})
export class AccessPageComponent {
  title = $localize`:@@Router.Access:Mis accesos`;
  description = "";
  image = "assets/images/teclado.jpg";

  applicantId: string = '';

  constructor(
    private readonly router: Router,
    private readonly authService: AuthService
  ) {
    this.applicantId = this.authService.getCurrentUser().documentNumber;
  }

  goToNewVehicle() {
    this.router.navigate(['/access/new/access']);
  }
}
